import { useState } from 'react';

const useSaveScrollPosition = () => {
  const [scrollPos, setScrollPos] = useState(0);
  const saveCurrentScrollPos = () => {
    setScrollPos(window.scrollY);
    window.scrollTo(window.scrollX, 0);
  };
  const resetToCurrentScrollPos = () => {
    window.scrollTo(window.scrollX, scrollPos);
  };
  return [saveCurrentScrollPos, resetToCurrentScrollPos];
};

export default useSaveScrollPosition;
